import { Observable } from "rxjs";
import { apiService } from "../../ApiService";
import { User } from "../../../model/User/User";

export const toggleNewsletter = (): Observable<User> => {
  return apiService.post({
    path: `public/account/newsletter`,
    requiresAuthPolicy: "user",
    crm: true,
  });
};
